import type { Styles } from '@chakra-ui/theme-tools'
import { mode } from '@chakra-ui/theme-tools'

export const styles: Styles = {
  global: (props) => ({
    body: {
      bg: mode('neutral.50', 'neutral.800')(props),
      color: mode('chakra-body-text', 'whiteAlpha.900')(props),
      fontFamily: 'body',
      fontSize: 'md',
      fontWeight: 400,
      lineHeight: 'base',
      transitionProperty: 'background-color',
      transitionDuration: 'normal',
    },
    '.chakra-collapse': {
      overflow: 'initial !important', // ve vychozim stavu je hidden a to zpusobuje zariznuti slideru v parametrech pojisteni
    },
    '*::placeholder': {
      color: 'chakra-placeholder-color',
      fontWeight: 'normal',
    },
    '*, *::before, &::after': {
      borderColor: mode('gray.200', 'whiteAlpha.300')(props),
      wordWrap: 'break-word',
    },
    p: {
      color: mode('chakra-body-text', 'whiteAlpha.900')(props),
    },
    strong: {
      fontWeight: 700,
    },
  }),
}
